import { CommonHelperFunctions, DashboardState, KeyCombinations } from "@kuika/kuika-cl-model";
import * as React from "react";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { isInsideModalOverlay } from "../../../shared/utility/modal-keyboard-scope";

declare let window: any;

export interface IShortcutListenerForToolbarState {}

export interface IShortcutListenerForToolbarProps {}

class ShortcutListenerForToolbar extends React.PureComponent<
  IShortcutListenerForToolbarProps & IWithSDProps,
  IShortcutListenerForToolbarState
> {
  isActive: boolean = false;

  constructor(props) {
    super(props);
    this.state = {};
  }

  shortcuts = [
    { key: KeyCombinations.ctrlS, execute: () => this.props.sd.saveScreen() },
    { key: KeyCombinations.ctrlZ, execute: () => this.props.sd.undo() },
    { key: KeyCombinations.ctrlY, execute: () => this.props.sd.redo() },
    { key: KeyCombinations.ctrlF, execute: () => {} },
    {
      key: KeyCombinations.ctrlD,
      execute: () => this.props.sd.cloneDI(this.props.sd.getActiveKuikaComponent()?.kuikaId)
    },
    {
      key: KeyCombinations.delete,
      execute: () => {
        const kuikaId = this.props.sd.getActiveKuikaComponent()?.kuikaId;
        const sd = this.props.sd.getScreenDesign();
        const isEditableTableColumnChild = CommonHelperFunctions.getIsEditableTableColumnChild(
          kuikaId,
          sd?.displayItems
        );
        if (isEditableTableColumnChild) {
          return;
        }
        if (kuikaId) {
          this.props.sd.deleteItemByKuikaId(kuikaId);
        }
      }
    }
  ];

  componentDidMount() {
    window.addEventListener("keydown", this.onKeyDown);
    this.checkIsActive();
  }

  componentDidUpdate() {
    this.checkIsActive();
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKeyDown);
  }

  private checkIsActive = () => {
    this.isActive =
      this.props.sd.dashboardState === DashboardState.design ||
      this.props.sd.dashboardState === DashboardState.reportDesigner;
  };

  private getIsEventPerformedForNonInputTarget = (e: any): boolean => {
    return (
      e.target?.tagName?.toUpperCase() === "DIV" ||
      e.target?.tagName?.toUpperCase() === "SPAN" ||
      e.target?.tagName?.toUpperCase() === "BODY"
    );
  };

  private getIsEventPerformedOnTextInputTarget = (e: any): boolean => {
    return (
      e.target?.tagName?.toUpperCase() === "INPUT" ||
      e.target?.tagName?.toUpperCase() === "TEXTAREA" ||
      (this.getIsEventPerformedForNonInputTarget(e) && e.target?.getAttribute("contenteditable") === "true")
    );
  };

  onKeyDown = (e: any) => {
    if (!this.isActive) return;
    const kc = CommonHelperFunctions.getKeyCombinationsFromKeysForDesignWindows(e);
    if (!kc) return;

    const isInMonacoEditor = e.target?.closest?.(".monaco-editor") !== null;
    const isInModal: boolean = isInsideModalOverlay(e.target);

    if (
      e.target instanceof HTMLElement &&
      (this.getIsEventPerformedOnTextInputTarget(e) || isInMonacoEditor || isInModal)
    ) {
      return;
    }

    const shortcut = this.shortcuts.find((s) => s.key === kc);

    if (shortcut) {
      e.preventDefault();
      e.stopPropagation();

      if (this.props.sd.isProcessingWithSpinner) {
        return;
      }

      shortcut.execute();
    }
  };

  render() {
    return <></>;
  }
}

const shortcutListenerForToolbar = withSD<IShortcutListenerForToolbarProps>(ShortcutListenerForToolbar);
export { shortcutListenerForToolbar as ShortcutListenerForToolbar };
